module.exports = __webpack_public_path__ + "static/media/2-kvesty.49042db9.jpg";